import {Injectable} from '@angular/core';
import {BackendConfiguration} from '@application/configuration/backend-configuration';
import {SignalrHubConnectionFactoryService} from '@vdw/angular-component-library';
import {Observable, Subject} from 'rxjs';
import {ProductionOrderLiteStatusChange} from './production-order-lite-status-change';
import {RealtimeProductionOrderLite} from './realtime-production-order-lite';

@Injectable()
export class SignalrProductionOrderLiteService implements RealtimeProductionOrderLite {
  private readonly productionOrderLiteStatusChangeSubject = new Subject<ProductionOrderLiteStatusChange>();

  public constructor(
    private readonly backendConfiguration: BackendConfiguration,
    private readonly signalrHubConnectionFactoryService: SignalrHubConnectionFactoryService
  ) {}

  public getProductionOrdersLiteStatusChanges(): Observable<ProductionOrderLiteStatusChange> {
    return this.signalrHubConnectionFactoryService.getSignalrHubEvents<ProductionOrderLiteStatusChange>(
      `${this.backendConfiguration.getProcessingHubEndPoint()}processing`,
      'OnProductionOrderLiteStatusChanged'
    );
  }
}
